"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calenzano": {
    "a5c8e499": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "baroncoli": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4fa2fabb": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "collina": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "030c0c49": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "leccio": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3873c101": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "osteria-degli-alberi": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "514969e7": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "querciola": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "910a305f": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "san-donato": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d09909c6": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-in-casaglia": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "254583a9": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "secciano": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f3db01db": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "sommaia": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f3df5fe1": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "skipSearch": false
    }],
    "spazzavento": [{
      "hkey": "60e59fc4",
      "slug": "calenzano",
      "name": "Calenzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;